import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IInvoice } from '../../../core/models/organisation.model';
import { ModalModule } from '../../../core/modal/modal.module';
import { SharedModule } from '../../../shared/shared.module';

@Component({
  selector: 'tax-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.sass'],
  standalone: true,
  imports: [
    ModalModule,
    TranslateModule,
    SharedModule,
  ],
})

export class InvoiceComponent {
  // @ts-ignore
  @Input() invoice: IInvoice;
}
